<template>
  <div id="app" class="bg-white min-h-screen relative overflow-x-hidden touch-pan-y">
    <!-- Top Left Logo - COMPLETELY IMMOVABLE -->
    <div class="fixed top-0 left-0 z-50 m-2 md:m-4 select-none pointer-events-none">
      <img src="/silversurfacelogo.jpg" alt="Silver Surface" class="w-24 h-12 md:w-32 md:h-16 object-contain" draggable="false" />
    </div>

    <!-- Dark Aura Background -->
    <div class="fixed inset-0 pointer-events-none">
      <div class="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-blue-900/20 to-black/30"></div>
      <div class="absolute inset-0 animate-pulse bg-gradient-to-tr from-black/10 via-purple-900/20 to-blue-900/20"></div>
      <div class="absolute top-0 left-0 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse"></div>
      <div class="absolute top-0 right-0 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
      <div class="absolute bottom-0 left-0 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
      <div class="absolute bottom-0 right-0 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse"></div>
      <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-r from-purple-600/20 to-blue-600/20 rounded-full blur-3xl animate-pulse"></div>
    </div>

    <nav class="bg-white/90 backdrop-blur-sm shadow-2xl border-b border-black/20 relative z-10">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between h-16">
          <div class="flex items-center pl-20 md:pl-36">
            <!-- Space for logo - logo is fixed to edge -->
          </div>
          <div class="flex items-center space-x-4">
            <router-link to="/" class="text-black hover:bg-gray-100 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 border border-transparent hover:border-black/30">Home</router-link>
            <router-link to="/dashboard" class="text-black hover:bg-gray-100 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 border border-transparent hover:border-black/30">Dashboard</router-link>
            <router-link to="/media" class="text-black hover:bg-gray-100 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 border border-transparent hover:border-black/30">Media</router-link>
            <router-link to="/prompting" class="text-black hover:bg-gray-100 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 border border-transparent hover:border-black/30">AI Prompting</router-link>
            <router-link to="/about" class="text-black hover:bg-gray-100 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 border border-transparent hover:border-black/30">About</router-link>
          </div>
        </div>
      </div>
    </nav>

    <main class="relative z-10">
      <router-view />
    </main>

    <footer class="bg-white/90 backdrop-blur-sm border-t border-black/20 relative z-10">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div class="text-center text-gray-700 text-sm">
          <p>&copy; 2024 Silver Surface. All rights reserved.</p>
          <p class="mt-2">Your brand, your vision</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const mobileMenuOpen = ref(false)

const navigation = [
  { name: 'Home', to: '/' },
  { name: 'Dashboard', to: '/dashboard' },
  { name: 'Media', to: '/media' },
  { name: 'AI Prompting', to: '/prompting' },
  { name: 'About', to: '/about' }
]
</script>

<style>
/* Page transition animations */
.page-enter-active,
.page-leave-active {
  transition: opacity 0.3s ease;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
}

/* Dark aura animations */
@keyframes pulse {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 0.8;
  }
}

.animate-pulse {
  animation: pulse 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Custom scrollbar for dark theme */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.5);
}
</style>